import { BuildingDTO } from "./building";
import { Resource } from "./resource";

export type RoofDto = {
  roofId?: number;
  status: BuildingParticleStatus;
  particleId?: number;
  description?: string;
  mainOrAnnex: MainOrAnnex;
  type: RoofType;
  subtype: RoofSubtype;
  skeleton: RoofSkeleton;
  orientation: RoofOrientation;
  covering: Covering;
  gutterMaterial: GutterMaterial;
  solarPanelsPresent: SolarPanelsPresent;
  solarPanelsPossible: SolarPanelsPossible;
  possibleSolarPanels: number;
  solarMapExtract: SolarMapExtract;
  sharePointPicturesFolderId?: string;
  sharePointPicturesFolderUrl?: string;
  insulated: Insulated;
  surfaceArea: number;
  numberOfDormers: number;
  numberOfSkylights: number;
  numberOfVeluxWindows: number;
  numberOfChimneys: number;
  installer: Resource;
  building: BuildingDTO;
  // Opleveringsdatum
  deliveryDate: Date;
  nextInspectionDate: Date;
}

export enum BuildingParticleStatus {
  TO_BE_CHECKED = "Na te kijken",
  GOOD = "Goede staat",
  BAD = "Slechte staat",
}

export enum SolarPanelsPossible {
  YES = "Ja",
  NO = "Nee",
  TO_BE_CHECKED = "Na te kijken"
}

export enum MainOrAnnex {
  TO_BE_CHECKED = "Na te kijken",
  MAIN = "Hoofddak",
  ANNEX = "Zijdak",
}

export enum RoofType {
  TO_BE_CHECKED = "Na te kijken",
  FLAT = "Plat",
  SLOPED = "Hellend",
}

export enum RoofSubtype {
  TO_BE_CHECKED = "Na te kijken",
  FLAT = "Plat",
  SADDLE = "Zadel",
  MANSARD = "Mansarde",
  LESSON = "Lessenaar",
}

export enum RoofSkeleton {
  TO_BE_CHECKED = "Na te kijken",
  PURLIN = "Gordingen",
  RAFTER = "Spanten",
}

export enum RoofOrientation {
  TO_BE_CHECKED = "Na te kijken",
  NOT_APPLICABLE = "Niet van toepassing",
  NZ = "N-Z",
  OW = "O-W",
  NO_ZW = "NO-ZW",
  NW_ZO = "NW-ZO",
}

export enum Covering {
  TO_BE_CHECKED = "Na te kijken",
  BITUMEN = "Bitumen",
  EPDM = "EPDM",
  ROOF_TILES = "Dakpannen",
  SLATE = "Leien",
  GREEN = "Groendak",
  SHEETS = "Platen",
  SHINGLES = "Shingles",
}

export enum GutterMaterial {
  TO_BE_CHECKED = "Na te kijken",
  BITUMEN_SLOPE = "Bitumen afschot",
  EPDM = "EPDM",
  BITUMEN = "Bitumen",
  ZINC = "Zink",
  UNKNOWN = "Onbekend",
}

export enum SolarPanelsPresent {
  YES = "Ja",
  NO = "Nee",
}

export enum SolarMapExtract {
  BINARY_FILE = "Binair bestand",
}

export enum Insulated {
  TO_BE_CHECKED = "Na te kijken",
  UNKNOWN = "Onbekend",
  INSULATED = "Geïsoleerd",
  NOT_INSULATED = "Niet geïsoleerd",
}